import { render, staticRenderFns } from "./CurrentPokedex.vue?vue&type=template&id=0f7b1e94&scoped=true&"
import script from "./CurrentPokedex.vue?vue&type=script&lang=js&"
export * from "./CurrentPokedex.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPokedex.vue?vue&type=style&index=0&id=0f7b1e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b1e94",
  null
  
)

export default component.exports